export default {
  computed: {
    ntrFADuomenys() {
      return this.ntrFADuomenysFull.filter(item => {
        return !item.hide
      })
    },
    ntrFADuomenysFull() {
      return [
        {
          value: 'kodas',
          label: 'Su fizinio asmens kodu',
          labelConfirm: 'Su asmens kodu',
          tooltip: 'Paieška. Turtas. FA duomenys. Asmens kodas',
          readonly: !this.showFAKodas,
          labelClass: this.showFAKodas ? '' : 'label-grey',
        },
        {
          value: 'gimimo_data',
          label: 'Su fizinio asmens gimimo data',
          labelConfirm: 'Su gimimo data',
          tooltip: 'Paieška. Turtas. FA duomenys. Gimimo data',
        },
        {
          value: 'vardas',
          label: 'Su fizinio asmens vardu ir pavarde',
          labelConfirm: 'Su vardu ir pavarde',
          tooltip: 'Paieška. Turtas. FA duomenys. Vardas Pavarde',
        },
      ]
    },
    ntrFADuomenysItem() {
      if (!this.mainData.ntr_fa_duomenys) {
        return {
          value: null,
          label: '',
          labelConfirm: '',
        }
      }

      return this.ntrFADuomenysFull.find(item => {
        return item.value === this.mainData.ntr_fa_duomenys
      })
    },
    showFAKodas() {
      return this.role('ntr3.fa_duomenys')
    },
    showIstoriniaiDuomenys() {
      return this.role('ntr3.istorija')
    },
  },
}
